export type OddsDotStatus = 'green' | 'red' | 'grey' | 'yellow'

export const ODDS_DOT_COLORS: Record<OddsDotStatus, string> = {
  green: '#4CAF50',
  red: '#F44336',
  grey: '#999999',
  yellow: '#F0B100',
}
const parseOdds = (odds: number | string | null | undefined) => {
  if (odds == null) return null
  const oddsStr = String(odds).trim().toUpperCase()

  if (oddsStr.includes('/')) {
    const [number, denominator] = oddsStr.split('/').map((n) => parseFloat(n.trim()))
    if (!Number.isNaN(number) && !Number.isNaN(denominator) && denominator !== 0)
      return number / denominator
    return null
  }
  const decimal = parseFloat(oddsStr)
  return Number.isNaN(decimal) ? null : decimal
}

export const normalizeOddsDisplay = (odds: number | string | null | undefined) => {
  if (odds == null) return null
  const oddsStr = String(odds).trim().toUpperCase()
  if (oddsStr === '1/1') return 'evn'
  return oddsStr
}
export function getOddsDotStatus(
  points: number | null | undefined,
  odds: number | string | null | undefined,
) {
  if (points === null || points === undefined) return 'grey'
  const pointsNum = typeof points === 'string' ? parseFloat(points) : points
  const oddsNum = parseOdds(odds)
  if (oddsNum == null || oddsNum === 0) return pointsNum > 0 ? 'yellow' : 'red'
  const multiplier = pointsNum / oddsNum
  if (Math.abs(multiplier - 1) < 0.01) return 'green'
  if (multiplier > 0) return 'yellow'
  return 'red'
}

export function getOddsDotColor(
  points: number | null | undefined,
  odds: number | string | null | undefined,
) {
  return ODDS_DOT_COLORS[getOddsDotStatus(points, odds)]
}

export function getOddsDotSx(
  points: number | null | undefined,
  odds: number | string | null | undefined,
) {
  return {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: getOddsDotColor(points, odds),
    flexShrink: 0,
  } as const
}

export function getOddsPlacedLabel(
  points: number | null | undefined,
  odds: number | string | null | undefined,
  isFinished?: boolean,
): string {
  if (isFinished === false) return '-'
  if (points === null || points === undefined) return '-'
  const pointsNum = typeof points === 'string' ? parseFloat(points) : points
  const oddsNum = parseOdds(odds)
  if (oddsNum == null || oddsNum === 0) return pointsNum > 0 ? 'Placed' : 'Unplaced'
  const multiplier = pointsNum / oddsNum
  if (Math.abs(multiplier - 1) < 0.01) return '1st'
  if (multiplier > 0) return 'Placed'
  return 'Unplaced'
}
